<ion-content
  class="multi-camera-content"
  [fullscreen]="true"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd($event)"
  (touchcancel)="onTouchEnd($event)"
>
  <div class="shutter-blackout" [class.active]="shutterBlackout()"></div>

  <div class="multi-camera-top">
    <ion-button color="primary" (click)="cancel()" shape="round">
      <ion-icon slot="icon-only" class="white" name="close-outline"></ion-icon>
    </ion-button>
    <ion-button color="primary" (click)="toggleFlash()" shape="round">
      <ion-icon
        class="white"
        slot="icon-only"
        [name]="flashMode() === 'off' ? 'flash-off-outline' : 'flash-outline'"
      ></ion-icon>
      @if (flashMode() === 'auto') {
      <span class="flash-auto">A</span>
      }
    </ion-button>
  </div>

  <div class="multi-camera-bottom">
    @if (zoomMax() > zoomMin()) {
    <div class="multi-camera-zoom">
      <ion-button
        fill="clear"
        color="light"
        [disabled]="zoomLevel() <= zoomMin()"
        (click)="adjustZoom(-0.1)"
      >
        <ion-icon
          slot="icon-only"
          class="white"
          name="remove-outline"
        ></ion-icon>
      </ion-button>
      <ion-range
        [min]="zoomMin()"
        [max]="zoomMax()"
        [step]="0.1"
        [value]="zoomLevel()"
        (ionChange)="changeZoom($event)"
      ></ion-range>
      <span class="zoom-value">{{ zoomLevel() | number : "1.1-1" }}×</span>
      <ion-button
        fill="clear"
        color="light"
        [disabled]="zoomLevel() >= zoomMax()"
        (click)="adjustZoom(0.1)"
      >
        <ion-icon slot="icon-only" class="white" name="add-outline"></ion-icon>
      </ion-button>
    </div>
    } @if (photos().length > 0) {
    <div class="multi-camera-thumbs">
      @for (photo of photos(); track photo.path) {
      <div class="thumb">
        <img [src]="photo.src" alt="" />
        <button class="thumb-remove" (click)="remove(photo)">
          <ion-icon name="close" class="white"></ion-icon>
        </button>
      </div>
      }
    </div>
    }

    <div class="multi-camera-controls">
      <ion-button color="primary" (click)="flip()" shape="round">
        <ion-icon
          class="white"
          slot="icon-only"
          name="camera-reverse-outline"
        ></ion-icon>
      </ion-button>

      <button
        class="shutter"
        [class.busy]="capturing()"
        [disabled]="capturing() || finishing()"
        (click)="capture()"
      ></button>

      <ion-button
        color="primary"
        shape="round"
        [disabled]="photos().length === 0 || finishing() || capturing()"
        (click)="done()"
      >
        <ion-icon
          slot="icon-only"
          class="white"
          name="checkmark-outline"
        ></ion-icon>
      </ion-button>
    </div>
  </div>
</ion-content>
